<mat-card class="mat-card--widget track-frame-details">
  <mat-card-content>
    <div class="container">
      <div class="row">
        <div class="col s12 m12 l10 offset-l2">
          <div class="tracking-buttons">
            <button
              class="btn btn-primary"
              *ngIf="framesInfo?.isLatest"
              [routerLink]="'/frame-to-come/track-shipment/' + framesInfo?.cartId"
            >
              Add Frames
            </button>
            <ng-container *ngIf="framesInfo?.frameItems.length > 0">
              <button class="btn btn-primary" (click)="printPackingList(framesInfo.cartId)">Print Packing Slip</button>
              <ng-container *ngIf="framesInfo.trackingNumber; else generateButton">
                <button
                  class="btn btn-primary"
                  [disabled]="!framesInfo.trackingNumber || printLoading"
                  (click)="printLabel(framesInfo.trackingNumber, framesInfo?.cartId)"
                >
                  <ng-container *ngIf="!printLoading; else framePrinting"> Print Shipping Label</ng-container>
                  <ng-template #framePrinting
                    ><fa-icon icon="spinner" [spin]="true"></fa-icon> Generating Label</ng-template
                  >
                </button>
                <mat-error *ngIf="errorMessage" class="mt-10 mb-10"
                  >Failed to Print Shipping Label. Please re-try in a couple of seconds</mat-error
                >
              </ng-container>
              <ng-template #generateButton>
                <button class="btn btn-primary" (click)="createShippingLabel(framesInfo)">Generate Label</button>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row" [id]="framesInfo.cartId">
        <table class="details-table mt-20">
          <thead>
            <tr class="details-header">
              <th>UPC</th>
              <th>Brand</th>
              <th>Style</th>
              <th>Color</th>
              <th>Patient's Name</th>
              <th>Frame Condition</th>
              <th>RX Order</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let items of framesInfo?.frameItems">
              <tr class="details-body">
                <td>{{ items.upc }}</td>
                <td>{{ items.brand }}</td>
                <td>{{ items.style }}</td>
                <td>{{ items.color }}</td>
                <td>{{ items?.firstName }} {{ items?.lastName }}</td>
                <td>{{ items?.frameCondition }}</td>
                <td>{{ items.rxOrderId }}</td>
              </tr>
            </ng-container>
            <ng-container *ngIf="framesInfo?.frameItems.length === 0">
              <tr>
                <td colspan="7" style="text-align: center;">
                  <p>Cart is empty. Please Add Frames to your cart.</p>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </mat-card-content>
</mat-card>
